import { Option } from '@imported/constellation';
import React, { useCallback } from 'react';
import { Controller, } from 'react-hook-form';
import { FieldWrapper } from '../../../styles/common.js';
import { getJourneyTariff, JOURNEY_EVENT, TAGGING_FIELDS, } from '../../../tagging/index.js';
import { Dropdown } from '../../Tagging/index.js';
const DropdownWrapper = ({ name, control, extendMargin = 40, dropdownOptions = [], customOnChange, dropdownProps, validation = {}, shouldUnregister = false, }) => {
    const renderComponent = useCallback(({ field: { ref, onChange, ...fieldState } }) => (React.createElement(Dropdown, { ...fieldState, ...dropdownProps, eventAction: JOURNEY_EVENT.FIELD_UPDATE, journeyAction: TAGGING_FIELDS.VALIDATION_ERROR, journeyAddons: JOURNEY_EVENT.ADDONS, journeyEvent: JOURNEY_EVENT.FORM_ENTRY, journeyTariff: getJourneyTariff, onChange: (event) => {
            customOnChange?.(event);
            onChange(event);
        } }, dropdownOptions.map((item) => {
        const { value, label, disabled } = item;
        return (React.createElement(Option, { disabled: Boolean(fieldState.value) && disabled, key: value, value: value }, label));
    }))), [dropdownProps, dropdownOptions, customOnChange]);
    return (React.createElement(FieldWrapper, { extendedWidth: 100, extendMargin: extendMargin },
        React.createElement(Controller, { control: control, name: name, render: renderComponent, rules: validation, shouldUnregister: shouldUnregister })));
};
export default DropdownWrapper;
//# sourceMappingURL=index.js.map